export const SALE = 'sale';
export const GOOD = 'good';
export const LOST = 'lost';
export const TASK = 'tasks';
export const LEASE = 'lease';
export const OTHER = 'Other';
export const EMAIL = 'email';
export const PRINT = 'print';
export const ORDER = 'orders';
export const PENDING = 'pending';
export const DURABLE = 'durable';
export const DAMAGED = 'damaged';
export const RETURNED = 'returned';
export const ASSIGNED = 'assigned';
export const ARCHIVED = 'archived';
export const INVENTORY = 'inventory';
export const CANCELLED = 'cancelled';
export const PERISHABLE = 'perishable';
export const NO_ATTRIBUTES = 'No Attributes';
export const INVOICE_NINJA = 'invoice_ninja';

// Example rows for the inventory import template, keyed by column name
export const IMPORT_SAMPLE_ROWS = [
  {
    'Item Name': 'Plastic Chair (sample)',
    Type: DURABLE,
    For: LEASE,
    Quantity: 50,
    'Quantity Unit': 'pieces',
    'Sale Price': 1500,
    'Lease Price': 200,
    'Purchase Price': 800,
    'Price Unit': 'KES',
    Category: 'Furniture',
    'Warranty Expiry Date': '2027-12-31',
    Description: 'Stackable white chair',
    Status: GOOD,
  },
  {
    'Item Name': 'Bottled Water 500ml (sample)',
    Type: PERISHABLE,
    For: SALE,
    Quantity: 120,
    'Quantity Unit': 'bottles',
    'Sale Price': 50,
    'Purchase Price': 30,
    'Price Unit': 'KES',
    Category: 'Beverages',
    'Expiry Date': '2027-06-30',
  },
  {
    'Item Name': 'Projector (sample)',
    Type: DURABLE,
    For: LEASE,
    Quantity: 2,
    'Quantity Unit': 'pieces',
    'Lease Price': 3000,
    'Purchase Price': 45000,
    'Price Unit': 'KES',
    Category: 'AV Equipment',
    'Warranty Expiry Date': '2028-03-31',
    Status: DAMAGED,
  },
];
